export default "/assets/images/app-slider.8b8b940a359f4639.mp4";